/*
 * F1 2026-10-14 (C-01): free-shipping bar and threshold amounts per market.
 * Threshold comes from snippets/free-shipping-threshold.liquid (one theme setting).
 * - Same currency as the visitor (e.g. DE 49 EUR on EUR, US 89 USD on USD): used as is.
 * - Shop currency (EUR) on another presentment currency: converted with Shopify.currency.rate
 *   and rounded UP to the cent (bar) or to the whole unit (text), so the page never promises
 *   free shipping below the amount the checkout converts.
 * - Any other combination: the bar hides itself (no promise rather than a wrong one).
 * Money is formatted with the presentment money format (KROWN.settings.shop_money_format,
 * rendered from Liquid shop.money_format), falling back to Intl.NumberFormat.
 */
if ( typeof window.ClavFreeShipping === 'undefined' ) {

  window.ClavFreeShipping = {

    activeCurrency() {
      return ( window.Shopify && Shopify.currency && Shopify.currency.active ) ? String(Shopify.currency.active).toUpperCase() : '';
    },

    // returns threshold in presentment cents, or null when it cannot be stated truthfully
    threshold(cents, currency, shopCurrency, wholeUnits) {
      cents = Number(cents);
      currency = String(currency || '').toUpperCase();
      shopCurrency = String(shopCurrency || '').toUpperCase();
      const active = this.activeCurrency();
      if ( !cents || !currency || !active ) return null;
      if ( currency === active ) return cents;
      if ( currency === shopCurrency && window.Shopify && Shopify.currency && Number(Shopify.currency.rate) > 0 ) {
        const converted = cents * Number(Shopify.currency.rate);
        return wholeUnits ? Math.ceil(converted / 100) * 100 : Math.ceil(converted);
      }
      return null;
    },

    format(cents, stripZeros) {
      const format = ( window.KROWN && KROWN.settings && KROWN.settings.shop_money_format ) || '';
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const withDelimiters = (precision, thousands, decimal) => {
        const parts = (cents / 100).toFixed(precision).split('.');
        const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        let frac = parts[1] ? decimal + parts[1] : '';
        if ( stripZeros && /^[.,]00$/.test(frac) ) frac = '';
        return whole + frac;
      };
      let value = null;
      if ( match ) {
        switch ( match[1] ) {
          case 'amount': value = withDelimiters(2, ',', '.'); break;
          case 'amount_no_decimals': value = withDelimiters(0, ',', '.'); break;
          case 'amount_with_comma_separator': value = withDelimiters(2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = withDelimiters(0, '.', ','); break;
          case 'amount_with_space_separator': value = withDelimiters(2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': value = withDelimiters(0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': value = withDelimiters(2, "'", '.'); break;
          case 'amount_with_period_and_space_separator': value = withDelimiters(2, ' ', '.'); break;
        }
      }
      if ( value !== null ) return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.activeCurrency(), minimumFractionDigits: stripZeros && cents % 100 === 0 ? 0 : 2 }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + this.activeCurrency();
      }
    },

    // fills <span data-free-shipping-amount> rendered by snippets/free-shipping-threshold.liquid
    fillAmounts(root) {
      (root || document).querySelectorAll('[data-free-shipping-amount]:not([data-filled])').forEach(el => {
        const t = this.threshold(el.dataset.cents, el.dataset.currency, el.dataset.shopCurrency, true);
        if ( t !== null ) {
          el.textContent = this.format(t, true);
          el.setAttribute('data-filled', '');
        }
      });
    }

  };

  if ( document.readyState === 'loading' ) {
    document.addEventListener('DOMContentLoaded', () => window.ClavFreeShipping.fillAmounts());
  } else {
    window.ClavFreeShipping.fillAmounts();
  }

}

if ( typeof customElements.get('shipping-notice') == 'undefined' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const textEl = this.querySelector('[data-js-free-shipping-text]');
      const sliderEl = this.querySelector('[data-js-free-shipping-slider]');
      if ( !textEl || !sliderEl ) return;

      const freeShippingThreshold = window.ClavFreeShipping.threshold(
        this.getAttribute('data-free-shipping'),
        this.getAttribute('data-free-shipping-currency'),
        this.getAttribute('data-shop-currency'),
        false
      );

      const wrapper = this.closest('[data-free-shipping-wrapper]') || this;
      if ( freeShippingThreshold === null ) {
        wrapper.style.display = 'none';
        return;
      }

      // cart.total_price = after cart-level and line-level discounts, the amount the checkout compares
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const freeShippingRemaining = cartTotal - freeShippingThreshold;

      let cartSliderWidth = 0;
      if ( freeShippingRemaining < 0 ) {
        textEl.textContent = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', window.ClavFreeShipping.format(Math.abs(freeShippingRemaining), false));
        cartSliderWidth = 100 - (Math.abs(freeShippingRemaining) * 100 / freeShippingThreshold);
      } else {
        textEl.textContent = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        cartSliderWidth = 100;
      }
      sliderEl.style.width = `${cartSliderWidth}%`;

    }

  }

  customElements.define('shipping-notice', ShippingNotice);

}
